export const API_URL = {
  findMyself: "/v1.4/webReservation/login",
  myReservations: "/regReservation/listDetailForPatient",
  scheduleList: "/regSchedule/find",
  getSchedule: "/regSchedule/get/:id",
  getReserveNo: "/regReservation/getReserveNo",
  makeReserve: "/regReservation/reserve/:id",
  getReservation: "/regReservation/getReservation/:id",
  cancelReserve: "/regReservation/bookingPageCancelReserve/:id",
  getRefShift: "/refShift/get"
}

export const HOSPITAL_NAME = window.HOSPITAL_NAME || process.env.REACT_APP_HOSPITAL_NAME

// 民國年
const year = new Date().getFullYear() - 1911

// 民國前20年 ~ 今年
export const YEARS = new Array(year + 21)
  .fill(true)
  .map((_, idx) => {
    const value = idx - 20
    const label = value < 0 ? `前${value * -1}` : value
    return { label, value }
  })
  .reverse()
export const MONTHS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

export const getDaysInMonth = function (month: number, year: number) {
  return new Date(year, month, 0).getDate()
}

export const DAY_MAP: Record<number, string> = {
  0: "日",
  1: "一",
  2: "二",
  3: "三",
  4: "四",
  5: "五",
  6: "六",
}
